export const tiposDeStatus = {
    I: 'Inativo',
    A: 'Ativo',
    default: 'Sem Status'
};

export const acoes = {
    I: 'Ativar',
    A: 'Inativar',
    default: ''
};
